import { observer } from 'mobx-react-lite'
import { VisuallyHidden } from '@react-aria/visually-hidden'
import Styles from '../../BlogMetadata.module.scss'
import { BlogMetadataCompositionReturn } from '../../hooks/useBlogMetadataComposition'
import {
  BlogMetadataHeader,
  BlogMetadataImageSection,
  BlogMetadataCategoriesSection,
  WixIntegrationFields,
  SummaryField,
  TitleField,
  SlugField,
} from '..'

/**
 * Wix-specific layout with custom field order
 * Order: Blog → Image → Writer → Excerpt → Categories → Tags → Title → Slug
 */
export const WixBlogMetadataLayout = observer(
  ({ integrationInfo, states, handlers, refs }: BlogMetadataCompositionReturn) => {
    return (
      <div className={Styles.container} data-testid="blog-metadata-v2">
        <VisuallyHidden>
          <input
            aria-label="Upload featured image"
            ref={refs.fileInputRef}
            type="file"
            multiple={false}
            onChange={handlers.imageHandlers.handleFileInputChange}
            accept="image/*"
          />
        </VisuallyHidden>

        <BlogMetadataHeader blogIntegrationsCount={integrationInfo.blogIntegrationsCount} />

        {/* Wix Blog & Writer */}
        <WixIntegrationFields
          integrationState={states.integrationState}
          handlers={handlers.enhancedIntegrationHandlers}
          isPostPublished={integrationInfo.isPostPublished}
        />

        {/* Featured Image & Alt Text */}
        <BlogMetadataImageSection imagesState={states.imageState} handlers={handlers.imageHandlers} />

        {/* Excerpt (Summary) */}
        <SummaryField
          label="Excerpt"
          value={states.formState.summary}
          onChange={handlers.enhancedFormHandlers.handleSummaryChange}
        />

        {/* Categories & Tags */}
        <BlogMetadataCategoriesSection
          categoriesState={states.categoriesState}
          categoriesHandlers={handlers.enhancedCategoriesHandlers}
          tagsState={states.tagsState}
          tagsHandlers={handlers.enhancedTagsHandlers}
        />

        {/* Title & Slug at the bottom */}
        <TitleField value={states.formState.title} onChange={handlers.enhancedFormHandlers.handleTitleChange} />

        <SlugField value={states.formState.slug} onChange={handlers.enhancedFormHandlers.handleSlugChange} />
      </div>
    )
  },
)
